import { render, staticRenderFns } from "./Commentary.vue?vue&type=template&id=4adb29d0&scoped=true&"
import script from "./Commentary.vue?vue&type=script&lang=js&"
export * from "./Commentary.vue?vue&type=script&lang=js&"
import style0 from "./Commentary.vue?vue&type=style&index=0&id=4adb29d0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adb29d0",
  null
  
)

export default component.exports